// extracted by mini-css-extract-plugin
var _1 = "LoginFormBody-modulehelpText__dB5uJ AuthHelpText-moduleAuthHelpText__HX0rS";
export { _1 as "helpText" }
